import type { FlowsType } from "@/types/entities/flows";

// Obtener el label del badge según status y review_status
export const getFlowBadgeLabel = (
  flow: Pick<FlowsType, "status" | "review_status">,
) => {
  // Si está publicado o deprecado, mostrar ese estado
  if (flow.status === "PUBLISHED") return "Publicado";
  if (flow.status === "DEPRECATED") return "Deprecado";

  // Si está en borrador o en proceso, mostrar el review_status
  switch (flow.review_status) {
    case "NOT_STARTED":
      return "Borrador";
    case "PENDING":
    case "IN_PROCESS":
      return "Sin validar";
    case "APPROVED":
      return "Validado";
    case "DENIED":
      return "Error en flujo";
    default:
      return "Borrador";
  }
};

// Obtener el color del badge según status y review_status
export const getFlowBadgeColor = (
  flow: Pick<FlowsType, "status" | "review_status">,
) => {
  // Si está publicado o deprecado, mostrar ese color
  if (flow.status === "PUBLISHED") return "success";
  if (flow.status === "DEPRECATED") return "danger";

  // Si está en borrador o en proceso, color según review_status
  switch (flow.review_status) {
    case "NOT_STARTED":
      return "action";
    case "PENDING":
    case "IN_PROCESS":
      return "warning";
    case "APPROVED":
      return "success";
    case "DENIED":
      return "danger";
    default:
      return "action";
  }
};
